const ARGENTINA_TIME_ZONE = "America/Argentina/Buenos_Aires";

export function formatDateTime(value: string | Date) {
  return new Intl.DateTimeFormat("es-AR", {
    dateStyle: "short",
    timeStyle: "short",
    hour12: false,
    timeZone: ARGENTINA_TIME_ZONE,
  }).format(new Date(value));
}

// datetime-local necesita una fecha sin zona; siempre mostrar la hora argentina.
export function dateTimeLocalValue(value: string | Date) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: ARGENTINA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const part = (type: string) => parts.find((p) => p.type === type)?.value;
  return `${part("year")}-${part("month")}-${part("day")}T${part("hour")}:${part("minute")}`;
}
